export default __webpack_public_path__ + "static/Icont-dollar-sign-e58f616fd116155abcb812867806fa4b.svg";